import { PaymentProcessorKind, DetectedFileKind } from '@signalvote/shared';
import { SUBSIDIARY_CODE } from '@/config';

/**
 * WinRed is a Republican-only donation platform and ActBlue is Democrat-only, so
 * neither should appear in the other party's build. We hide WinRed on the
 * `democrat` build and ActBlue on the `gop` build; the `nonpartisan` build (which
 * serves campaigns of any affiliation) shows both. Every other processor is
 * always visible.
 *
 * This is a build-time presentation filter only — the backend catalog still
 * returns every processor, so nothing here changes what the API accepts.
 */
function isPartisanPlatformHidden(
  platform: 'winred' | 'actblue',
  subsidiary: string,
): boolean {
  if (platform === 'winred') return subsidiary === 'democrat';
  if (platform === 'actblue') return subsidiary === 'gop';
  return false;
}

/** Is this processor kind visible in the current build's processor setup? */
export function isProcessorKindVisibleForSubsidiary(
  kind: PaymentProcessorKind,
  subsidiary: string = SUBSIDIARY_CODE,
): boolean {
  if (kind === PaymentProcessorKind.WinRed) return !isPartisanPlatformHidden('winred', subsidiary);
  if (kind === PaymentProcessorKind.ActBlue) return !isPartisanPlatformHidden('actblue', subsidiary);
  return true;
}

/** Is this file-upload kind visible in the current build's kind picker? */
export function isDetectedFileKindVisibleForSubsidiary(
  kind: DetectedFileKind,
  subsidiary: string = SUBSIDIARY_CODE,
): boolean {
  if (kind === DetectedFileKind.WinRedContributions) return !isPartisanPlatformHidden('winred', subsidiary);
  if (kind === DetectedFileKind.ActBlueContributions) return !isPartisanPlatformHidden('actblue', subsidiary);
  return true;
}
